import {Brick, registerBrick, Service} from 'olympe';

export default class GetUserServiceStatus extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setBackendId
     * @param {function(Map)} setOnlineFrontends
     * @param {function(Map)} setFrontendsCheckingAPR
     * @param {function(Map)} setFrontendIdUserLink
     */
    update($, inputs, [forwardEvent, setBackendId, setOnlineFrontends, setFrontendsCheckingAPR, setFrontendIdUserLink]) {
        Service.get('userService', {})
            .then((data) => {
                setBackendId(data.backendId);
                setOnlineFrontends(data.onlineFrontends);
                setFrontendsCheckingAPR(data.frontendsCheckingAPR);
                setFrontendIdUserLink(data.frontendIdUserLink);
                forwardEvent();
            });
    }
}

registerBrick('0198cd05292ba1bfc9b3', GetUserServiceStatus);
